import { useWixPatternsContainer } from '@wix/bex-core/react';

export const BM_HARMONY_THEME_EXPERIMENT = 'bmHarmonyTheme';

/** Whether the BM harmony visual refresh is enabled for this user. */
export function useBmHarmonyTheme(): boolean {
  const { experiments } = useWixPatternsContainer();
  return experiments.enabled(BM_HARMONY_THEME_EXPERIMENT);
}
